
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.4901 20.49L3.51012 3.51C3.12012 3.12 2.49012 3.12 2.10012 3.51C1.71012 3.9 1.71012 4.53 2.10012 4.92L5.02012 7.84C5.02012 7.9 5.00012 7.95 5.00012 8V19C5.00012 20.1 5.90012 21 7.00012 21C7.00012 21.55 7.45012 22 8.00012 22C8.55012 22 9.00012 21.55 9.00012 21H15.0001C15.0001 21.55 15.4501 22 16.0001 22C16.5501 22 17.0001 21.55 17.0001 21C17.3401 21 17.6501 20.91 17.9301 20.76L19.0701 21.9C19.4601 22.29 20.0901 22.29 20.4801 21.9C20.8801 21.51 20.8801 20.88 20.4901 20.49ZM8.75012 18C8.34012 18 8.00012 17.66 8.00012 17.25V10.83L9.50012 12.33V17.25C9.50012 17.66 9.16012 18 8.75012 18ZM12.0001 18C11.5901 18 11.2501 17.66 11.2501 17.25V14.08L12.7501 15.58V17.25C12.7501 17.66 12.4101 18 12.0001 18ZM12.0001 9C12.4101 9 12.7501 9.34 12.7501 9.75V9.92L14.5001 11.67V9.75C14.5001 9.34 14.8401 9 15.2501 9C15.6601 9 16.0001 9.34 16.0001 9.75V13.17L19.0001 16.17V8C19.0001 6.9 18.1001 6 17.0001 6H15.0001V3C15.0001 2.45 14.5501 2 14.0001 2H10.0001C9.45012 2 9.00012 2.45 9.00012 3V6H8.83012L11.8601 9.03C11.9101 9.02 11.9501 9 12.0001 9ZM10.5001 3.5H13.5001V6H10.5001V3.5Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-no-luggage`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNoLuggage

    ```js
    <b-new-b-icon-no-luggage />
    ```
</docs>


